import { RACTabs, Grid } from '@rentacenter/racstrap';
import React, { useMemo } from 'react';
import BasicInformation from './BasicInformation';
import { Breadcrumb } from '../../shared/Breadcrumb';

export const CSNew = () => {
  const AVAILABLE_TABS = useMemo(() => {
    return ['Basic Information'];
  }, []);

  return (
    <>
      <Breadcrumb />
      <Grid
        key={'TabComponentContainer'}
        id={'TabComponentContainer'}
        container
      >
        <RACTabs
          key={'TabComponent'}
          id={'TabComponent'}
          defaultValue={0}
          tabs={AVAILABLE_TABS}
          contentForTabs={[<BasicInformation key="Basic Information" />]}
        />
      </Grid>
    </>
  );
};
